import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { notificationList, notificationReadSingle, notificationReadAll, logOutApi } from '../../Context/api';
import { useContext } from 'react'
import { Notifications } from '../../App';
import { commonMessage, statusCodes } from '../../Constants/generalConfig';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import PaginationCom from '../Pagination/pagination';
import Spinner from '../Spinner/spinner';

const Notification = () => {
    const { count, setCount } = useContext(Notifications)
    const [checked, setChecked] = useState(true)
    const adminData = JSON.parse(localStorage.getItem('adminData'))
    const [listNotification, setListNotification] = useState([])
    const [status, setStatus] = useState()
    const [spinner, setSpinner] = useState(false)
    const [pageCount, setPageCount] = useState(1)
    const [page, setPage] = useState(1)
    const PER_PAGE = 10
    const navigate = useNavigate()

    useEffect(() => {

        listNotifications()
    }, [page, status])


    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData?.deviceId, userId: adminData?.userId, type: adminData?.roleTitle == "SERVICE_PROVIDER" ? 'WEBPROVIDER' : 'WEBSTAFF' }, { headers: { Authorization: `Bearer ${adminData?.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }
    const listNotifications = (st) => {
        const data = {
            receiver: adminData?.userId,
            page: page,
            count: PER_PAGE,
            isReaded: status,
            roleTitle: adminData?.roleTitle
        }
        // if (adminData?.roleTitle == roleNames.STAFF) {
        //     data['providerId'] = adminData?.createdbyId
        // }
        setSpinner(true)
        axios.post(notificationList(), { ...data }, { headers: { Authorization: `Bearer ${adminData?.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setListNotification(resp.data)
                setPageCount(resp.data.totalCount)
                setCount({ totalCount: resp.data.unreadedCount })
                setSpinner(false)
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                setListNotification([])
                setPageCount(1)
                setCount({})
                setSpinner(false)
            }
        })
            .catch(() => {
                setSpinner(false)
                toast.error(commonMessage.networkError)
            })
    }
    const singleReadNotification = (id) => {
        const data = {
            notification_id: id,
            reader_id: adminData?.userId,
        }
        setSpinner(true)
        axios.post(notificationReadSingle(), { ...data }, { headers: { Authorization: `Bearer ${adminData?.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                toast.success(resp.data.message)
                listNotifications()
                setSpinner(false)
            }
            else {
                toast.error(resp.data.message)
                setSpinner(false)
            }
        }).catch(() => {
            setSpinner(false)
            toast.error(commonMessage.networkError)
        })
    }
    const allNotificationRead = () => {
        const data = {
            user_id: adminData?.userId,
        }
        setSpinner(true)
        axios.post(notificationReadAll(), { ...data }, { headers: { Authorization: `Bearer ${adminData?.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                // toast.success(resp.data.message)
                listNotifications()
                setSpinner(false)
            }
            else {
                toast.error(resp.data.message)
                setSpinner(false)
            }
        }).catch(() => {
            setSpinner(false)
            toast.error(commonMessage.networkError)
        })
    }
    const navigation = (item) => {
        singleReadNotification(item._id)
        // if (item.type === 'BOOKAPPOINTMENT' || item.type === 'CANCELAPPOINTMENT' || item.type === 'RESCHEDULEDAPPOINTMENT' || item.type === 'DELETAPPOINTMENT') {
        //     navigate(`/layout/appointmentList/appointmentView/${item.type_id}`)
        // }
    }
    return (
        <>
            {spinner ? <Spinner /> : null}
            <ToastContainer />
            <section>
                <div className="cus-padd cusheight">
                    <header>
                        <h2 className='page-tittle'>
                            Notifications
                        </h2>
                        <hr />
                    </header>
                    <div className="row">
                        <div className="col-sm-12 listpadding">
                            <div className="d-flex justify-content-between">
                                <div className='mb-3'>
                                    <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                                        <input type="radio" className="btn-check" name="btnradio" id="btnradio1" autoComplete="off" defaultChecked={checked ? true : false} onClick={() => { setStatus(true); setChecked(true); setPage(1) }} />
                                        <label className="btn btn-outline-secondary" htmlFor="btnradio1" >All</label>

                                        <input type="radio" className="btn-check" name="btnradio" id="btnradio2" autoComplete="off" defaultChecked={!checked ? true : false} onClick={() => { setStatus(false); setChecked(false); setPage(1) }} />
                                        <label className="btn btn-outline-secondary" htmlFor="btnradio2" >Unread</label>
                                    </div>
                                </div>
                                {
                                    listNotification.unreadedCount == 0 ?
                                        <h6 style={{ cursor: 'pointer', pointerEvents: "none", color: "#aaaaaa" }}>Mark All Read</h6>
                                        :
                                        <h6 onClick={() => { allNotificationRead(); }} style={{ cursor: 'pointer' }}>Mark All Read</h6>
                                }
                            </div>
                            <div className="table-responsive" style={{ overflowX: 'hidden' }}>
                                <table className="table ">
                                    <thead className=" text-center table-dark pt-5">
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Title</th>
                                            <th scope="col">Description</th>
                                            <th scope="col">Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            listNotification.data?.map((item, index) =>
                                                <React.Fragment key={item._id}>
                                                    <div className='mt-2'></div>
                                                    <tr onClick={() => item.isReaded == true ? null : navigation(item)}
                                                        className={item.isReaded === true ? 'readtable' : 'notifaication_Tab'} style={{ cursor: 'pointer' }}>
                                                        <td>{PER_PAGE * (page - 1) + index + 1}</td>
                                                        <td>{item.title}</td>
                                                        <td>{item.message}</td>
                                                        <td>{moment(item.createdAt).format('DD-MM-YYYY')}</td>
                                                    </tr>
                                                </React.Fragment>
                                            )
                                        }
                                    </tbody>
                                </table>
                                <div className='w-100 d-flex justify-content-center'>
                                    {
                                        pageCount > 10 &&
                                        <PaginationCom setpage={setPage} count={Math.ceil(pageCount / PER_PAGE)} page={page} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Notification